import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "bg-white divide-y" }
const _hoisted_2 = { class: "flex-1 p-2 capitalize text-left text-gray-400" }
const _hoisted_3 = { class: "flex-1 p-2 text-left" }




export default /*#__PURE__*/_defineComponent({
  props: {
    data: null
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("ul", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.data, ([key, value]) => {
      return (_openBlock(), _createElementBlock("li", {
        key: key,
        class: "flex"
      }, [
        _createElementVNode("p", _hoisted_2, _toDisplayString(key), 1),
        _createElementVNode("p", _hoisted_3, _toDisplayString(value), 1)
      ]))
    }), 128))
  ]))
}
}

})